import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import { useTheme } from '@mui/styles';
const Completed = (props) => {
    const theme = useTheme();
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center', alignItems: 'center', pt: 2 } },
        React.createElement(Box, { sx: {
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: theme.palette.success.light,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement(DoneIcon, null)),
        React.createElement(Typography, { variant: 'subtitle2' }, "Verification Complete"),
        React.createElement(Typography, { variant: 'caption' }, "Thank you for providing the originator information. Your deposit has been fully verified"),
        React.createElement(Button, { variant: 'contained', fullWidth: true, onClick: () => {
                props.onClose();
            } }, "Return to Deposits")));
};
export default Completed;
